/* 🤖 this file was generated by svg-to-ts */
export const kzIconsHome: {
  name: 'home';
  data: string;
} = {
  name: 'home',
  data: `<svg viewBox="0 0 24 22"><path fill="currentColor" d="M9.332 19.938h-4.68V8.357l.014-.011v-.172l7.333-6.212 7.333 6.214v1.449h-.008v10.312h-4.658V13.75c0-.759-.598-1.375-1.334-1.375h-2.666c-.736 0-1.334.616-1.334 1.375zM20.666 22a.678.678 0 0 0 .666-.688V9.87l1.146.971a.76.76 0 0 0 .428.16c.172 0 .4-.11.511-.246l.428-.528A.813.813 0 0 0 24 9.785a.79.79 0 0 0-.24-.529L13.493.56C13.135.25 12.465 0 11.999 0c-.467 0-1.137.25-1.495.559L.239 9.256A.79.79 0 0 0 0 9.784c0 .137.07.335.155.44l.427.53a.75.75 0 0 0 .511.245.76.76 0 0 0 .428-.16l1.144-.969v2.505h-.012v8.938a.684.684 0 0 0 .67.687z"/></svg>`
};
